import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {fetchTracked} from "../../catalog/infrastructure/CatalogService";
import {useComercialContext} from "../../../comercial/ComercialContext";

export const TrackedProductsSwiper = () => {
  const { actingAsCliente } = useComercialContext();
  const fetchFn = () => fetchTracked(actingAsCliente?.numCliente ?? null);
  return (
    <ProductSwiper title={'PRODUCTOS PENDIENTES'} fetchFn={fetchFn} />
  );
};
